var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imageSrc)?_c('image-preview',{staticClass:"payee-info-preview",attrs:{"src":_vm.imageSrc,"size":"100%","remove":""},on:{"remove":_vm.$listeners['remove']}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }